import React from "react";
import NextScript from "next/script";

const MetaPixel = ({ pixelId: pixelIdProp }: { pixelId?: string | null } = {}) => {
  // DB-backed prop wins, else NEXT_PUBLIC_META_PIXEL_ID.
  const pixelId =
    (pixelIdProp && pixelIdProp.trim()) || process.env["NEXT_PUBLIC_META_PIXEL_ID"];

  // Return null silently if ID is not configured (no errors/warnings)
  if (!pixelId) {
    return null;
  }

  return (
    <>
      <link rel="preconnect" href="https://connect.facebook.net" />
      <link rel="preconnect" href="https://www.facebook.com" />
      {/* Meta Pixel Code */}
      <NextScript
        id="meta-pixel-script"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            !function(f,b,e,v,n,t,s){
              if(f.fbq)return;
              n=f.fbq=function(){
                n.callMethod ?
                  n.callMethod.apply(n,arguments) : n.queue.push(arguments)
              };
              if(!f._fbq)f._fbq=n;
              n.push=n;
              n.loaded=!0;
              n.version='2.0';
              n.queue=[];
              t=b.createElement(e);
              t.async=!0;
              t.src=v;
              s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)
            }(window, document, 'script',
              'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${pixelId}');
            fbq('track', 'PageView');
          `,
        }}
      />
      {/* End Meta Pixel Code */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
};

export default MetaPixel;
